import React, { useEffect, useState } from 'react';
import { useLanguage } from '../../../shared/contexts/LanguageContext';
import useTranslation from '../../../shared/hooks/useTranslation';
import PartnerCard from '../../../shared/components/PartnerCard';
import { getApiBaseUrl } from '../../../core/config/api';

interface PartnerFromApi {
  id: string;
  name: string;
  description: string;
  discordLink: string;
  color: 'blue' | 'red' | 'green' | 'purple' | 'yellow' | 'orange';
  icon?: string;
  createdDate?: string;
}

const PartnersSection: React.FC = () => {
  const { language } = useLanguage();
  const { t } = useTranslation(language);
  const [activePartners, setActivePartners] = useState<PartnerFromApi[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const apiUrl = getApiBaseUrl();
    fetch(`${apiUrl}/api/config/partenaires/public`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success && Array.isArray(data.data)) {
          setActivePartners(data.data);
        }
      })
      .catch(() => setActivePartners([]))
      .finally(() => setLoading(false));
  }, []);

  if (loading || activePartners.length === 0) {
    return null;
  }

  return (
    <section className="py-20 relative z-10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6 text-gradient">
            {t('partners.title')}
          </h2>
          <p className="text-xl md:text-2xl text-gray-300 max-w-4xl mx-auto leading-relaxed">
            {t('partners.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {activePartners.map((partner) => (
            <PartnerCard
              key={partner.id}
              name={partner.name}
              description={partner.description}
              discordLink={partner.discordLink}
              color={partner.color}
              icon={partner.icon}
              createdDate={partner.createdDate}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;

